// const IP = "https://learnapi.alghaith.ae";
// const IP = "http://localhost:5001";
const dev = process.env.NODE_ENV === "development";
const IP = dev ? "http://localhost:7001" : "https://linguishdevapi.kdev.co.in";

export { IP };
